import { useCallback, useEffect } from "react";

import AuthService from "services/Auth";
import userService from "services/User";
import { useSocket } from "providers/SocketProvider";

export const useRolePermissionsListener = () => {
  const { socket } = useSocket();

  const refresh = useCallback(async () => {
    try {
      const me = await userService.getUserSettings();
      AuthService.setRole(me.role);
    } catch (error) {
      console.error("Failed to refresh role permissions", error);
    }
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on("role_permissions_updated", refresh);
      socket.on("connect", refresh);
    }

    return () => {
      if (socket) {
        socket.off("role_permissions_updated", refresh);
        socket.off("connect", refresh);
      }
    };
  }, [socket, refresh]);
};

export const RolePermissionsListener = () => {
  useRolePermissionsListener();
  return null;
};
